import { render } from "./PeopleExport.vue?vue&type=template&id=396b71d8"
import script from "./PeopleExport.vue?vue&type=script&lang=js"
export * from "./PeopleExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__